import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './pages/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/FreestandingPannels';

import BottemlessBunks from './pages/BottemlessBunks';
import BaleFeeder from './pages/BaleFeeder';
import DriveoverGates from './pages/DriveoverGates';
import PurposeBuilt from './pages/PurposeBuilt';
import Feederpanels from'./pages/Feederpanels';
import ContinuousPannels from './pages/ContinuousPannels';
import Gates from './pages/Gates';


function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/FreestandingPannels" element={<Contact />} />

        <Route path="/balefeeder" element={<BaleFeeder />} />
        <Route path="/bottemlessbunks" element={<BottemlessBunks />} />
        <Route path="/driveovergates" element={<DriveoverGates />} />
        <Route path="/purposebuilt" element={<PurposeBuilt />} />
        <Route path="/Feederpanels" element={<Feederpanels />} />
        <Route path="/continuouspannels" element={<ContinuousPannels />} />
        <Route path="/gates" element={<Gates />} />
        
      </Routes>
    </Router>
  );
}

export default App;